export const APP_VERSION_FILE_NAME = './version.json';

export type AppVersionInfo = {
    commit: string;
    date: Date;
    buildEnv: string;
}

export function isAppVersionValid(appVersion: AppVersionInfo): boolean {
    return !!(appVersion.commit && appVersion.commit.length > 4
        && appVersion.date && !isNaN(appVersion.date.valueOf())
        && appVersion.buildEnv);
}

export function areVersionsSame(a: AppVersionInfo, b: AppVersionInfo): boolean {
    return !isAppVersionValid(a) && !isAppVersionValid(b) ?
        a.commit === b.commit
        && a.buildEnv === b.buildEnv
        :
        a.commit === b.commit
        && a.date.valueOf() === b.date.valueOf()
        && a.buildEnv === b.buildEnv;
}

export function printAppVersion(appVersion: AppVersionInfo): string {
    return `commit: ${appVersion.commit}, build date: ${appVersion.date.toString()}, buildEnv: ${appVersion.buildEnv}`;
}


export const generateAppVersionInfo = (jsonObject: any): AppVersionInfo | undefined => {
    if ('commit' in jsonObject && 'date' in jsonObject && 'buildEnv' in jsonObject) {
        const appVersion: AppVersionInfo = { commit: jsonObject['commit'], date: jsonObject['date'], buildEnv: jsonObject['buildEnv'] }
        return appVersion;
    }

    return undefined;
}
